var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg360DashboardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_3559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 -3.01379e-05C8.48993 -3.01379e-05 8.47818 -3.01379e-05 8.4681 -3.01379e-05C8.45971 -3.01379e-05 8.45131 -0.00170898 8.44292 -0.00170898C8.41102 -0.00170898 8.37912 0.00164871 8.34723 0.00332756C3.7304 0.0872699 0.00167885 3.863 0 8.49829V8.49997V8.50165C0.00167885 13.147 3.75054 16.9328 8.3808 16.9966C8.40095 16.9966 8.42109 17 8.44124 17C8.44628 17 8.45299 17 8.45803 17C8.47146 17 8.48489 17.0016 8.5 17.0016C13.1857 17.0016 16.9983 13.189 16.9983 8.50165C16.9983 3.81431 13.1873 -3.01379e-05 8.5 -3.01379e-05ZM16.1488 8.08026H13.1521C13.0765 5.14731 12.2119 2.64751 10.9243 1.23392C13.8354 2.20933 15.9759 4.88709 16.1488 8.08026ZM8.08029 0.874649V8.08026H4.57318C4.68062 4.35154 6.21173 1.2356 8.08029 0.874649ZM8.08029 8.91968V16.1236C6.21173 15.7627 4.68062 12.6484 4.57318 8.91968H8.08029ZM8.91971 16.0968V8.91968H12.311C12.2052 12.5712 10.7362 15.6334 8.91971 16.0968ZM8.91971 8.08026V0.903189C10.7362 1.36823 12.2052 4.43045 12.311 8.08026H8.91971ZM5.91122 1.291C4.64873 2.71299 3.80595 5.18593 3.73208 8.08026H0.851175C1.02074 4.94753 3.08404 2.30838 5.91122 1.291ZM0.851175 8.91968H3.73208C3.80762 11.8157 4.65041 14.2886 5.9129 15.7106C3.08404 14.6916 1.02242 12.0541 0.851175 8.91968ZM10.9226 15.766C12.2119 14.3541 13.0765 11.8543 13.1521 8.91968H16.1488C15.9759 12.1145 13.8354 14.7923 10.9226 15.766Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_3559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360DashboardWhite);
export default __webpack_public_path__ + "static/media/360 Dashboard_White.8c4c39db2c87bc95114c8e284388fee9.svg";
export { ForwardRef as ReactComponent };